<template>
  <div>
    <p v-if="showProgress">{{ $t("downloadtime_notification") }}</p>
    <ProgressBar
      v-if="showProgress"
      :max="allElementsCounts"
      :current="loadedElements"
    />
    <div class="d-flex">
      <button class="button btn " @click="getAll" v-if="isntCachingOrDeleting">
        <p>{{ $t("save_settings") }}</p>
      </button>
    </div>
    <p v-if="failedCache" class="errortext">
      {{ $t("errorMessageDownloadModal") }}
    </p>
  </div>
</template>

<script>
import {
  deleteCachedElementsForLanguageInDB,
  getAll
} from "@/services/caching/cachingHelpers";
import { isOnline } from "@/services/http/httpService.js";
import { languageAdapter } from "@/services/languageAdapter";
import ProgressBar from "./ProgressBar";

export default {
  name: "DownloadMenu",
  data() {
    return {
      storeNames: ["videos", "pdfs"]
    };
  },
  props: {
    chosenLanguages: Array
  },
  components: {
    ProgressBar
  },
  computed: {
    allElementsCounts() {
      return this.$store.state.sumElementsToLoad;
    },
    showProgress() {
      return this.$store.state.isCachingElements;
    },
    loadedElements() {
      return this.$store.state.loadedElements;
    },
    failedCache() {
      return this.$store.state.failedCache;
    },
    isntCachingOrDeleting() {
      return (
        !this.$store.state.isCachingElements &&
        !this.$store.state.isDeletingElements
      );
    }
  },
  beforeUnmount() {
    this.$store.commit("setCachingError", false);
  },
  methods: {
    async getAll() {
      this.$store.state.failedCache = false;

      const videosToDownload = this.$store.getters.getVideosInDifferentLanguages(
        this.chosenLanguages
      );
      const pdfsToDownload = this.$store.getters.getPdfsInDifferentLanguages(
        this.chosenLanguages
      );
      this.$store.commit("setSumElementsToLoad", {
        sumOfElements: videosToDownload.length + pdfsToDownload.length
      });
      const languages = languageAdapter.supportedLanguages();
      for (let i in languages) {
        const language = languages[i];
        if (!this.chosenLanguages.includes(language)) {
          await deleteCachedElementsForLanguageInDB(language);
        }
      }
      if (!(await isOnline())) {
        this.$store.commit("setCachingError", true);
      } else {
        await getAll(Object.values(videosToDownload), pdfsToDownload);
      }
      this.$store.dispatch("setCachingStatus", ["de", "en"]);
    }
  }
};
</script>

<style scoped>
.button {
  margin-bottom: 10px;
  margin-left: auto;
  color: #00aeef;
}
.errortext {
  color: red;
  font-size: 16px;
}
</style>
